import {
	messages
} from "@/utils/locale.js"
export const useLangStore = defineStore('lang', {
	state: () => {
		const savedLocale = uni.getStorageSync('app_locale')
		return {
			currentLocale: savedLocale || 'ru',
			messages
		};
	},
	getters: {
		locale: (state) => state.currentLocale,
		$t: (state) => (key) => {
			let messages = state.messages
			let lang = state.currentLocale
			 if (messages[lang] == undefined) {
			            lang = 'ru'  // 改为回退到俄语
			        }
			 // 处理嵌套键
			const keys = key.split('.')
			let translation = messages[lang]
			for (const k of keys) {
			    translation = translation?.[k]
			}
			return translation || key          
		}
	},
	actions: {
		setLocale(locale) {
			if (this.currentLocale !== locale) {
				uni.setStorageSync('app_locale', locale)
				getApp().$locale = locale
				this.currentLocale = locale
				// 刷新当前页面
				const pages = getCurrentPages()
				const currentPage = pages[pages.length - 1]
				if (currentPage && currentPage.$vm) {
					currentPage.$vm.$forceUpdate()
				}
			}
		},
		toggleLanguage() {
			const langs = ['ru', 'kz'];
			const currentIndex = langs.indexOf(this.currentLocale);
			const nextIndex = (currentIndex + 1) % langs.length;
			this.setLocale(langs[nextIndex]);
		}
	}
});